import React from 'react'
import styled from 'styled-components'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { ToastContainer } from 'react-toastify'

import Header from './header'
import Footer from './footer'

import './layout.sass'

export default styled(({ className, root, children }) =>
  <div className={className}>
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.RECAPTCHA_SITE_KEY}
      useRecaptchaNet={true}>

      <Header root={root} />
      <main>{children}</main>
      <Footer root={root} />

      <ToastContainer
        position='top-right'
        autoClose={5000}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

    </GoogleReCaptchaProvider>
  </div>
)`

`
